__turbopack_context__.v({
  "Address": "ImageTeaser-module-scss-module__b9x-5q__Address",
  "AddressIcon": "ImageTeaser-module-scss-module__b9x-5q__AddressIcon",
  "AddressMore": "ImageTeaser-module-scss-module__b9x-5q__AddressMore",
  "AddressWrapper": "ImageTeaser-module-scss-module__b9x-5q__AddressWrapper",
  "Bottom": "ImageTeaser-module-scss-module__b9x-5q__Bottom",
  "Content": "ImageTeaser-module-scss-module__b9x-5q__Content",
  "Description": "ImageTeaser-module-scss-module__b9x-5q__Description",
  "Expertises": "ImageTeaser-module-scss-module__b9x-5q__Expertises",
  "Image": "ImageTeaser-module-scss-module__b9x-5q__Image",
  "ImageTeaser": "ImageTeaser-module-scss-module__b9x-5q__ImageTeaser",
  "Services": "ImageTeaser-module-scss-module__b9x-5q__Services",
  "Title": "ImageTeaser-module-scss-module__b9x-5q__Title",
});
